// extracted by mini-css-extract-plugin
module.exports = {"moveMenuWrapper":"MovePopup_moveMenuWrapper__2Iby1","attendeesHolder":"MovePopup_attendeesHolder__2LzzJ"};